import { notification } from 'antd';

interface Notifier {
  timer: number;
  setTimer: (sec: number) => void;
  success: (message: string, description?: string, duration?: number) => void;
  error: (message: string, description?: string, duration?: number) => void;
  info: (message: string, description?: string, duration?: number) => void;
}

export const notifier: Notifier = {
  timer: 6,

  setTimer(sec: number) {
    this.timer = sec;
  },

  success(message: string, description = '', duration = notifier.timer) {
    notification.success({
      message,
      description,
      className: description ? 'notifier-content' : 'notifier-no-content',
      duration,
    });
  },

  error(message: string, description = '', duration = notifier.timer) {
    notification.error({
      message,
      description,
      className: description ? 'notifier-content' : 'notifier-no-content',
      duration,
    });
  },

  info(message: string, description = '', duration = notifier.timer) {
    notification.info({
      message,
      description,
      className: description ? 'notifier-content' : 'notifier-no-content',
      duration,
    });
  },
};

export default notifier;
